// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"354":"38837743","594":"aa3ab7da","814":"be015fc9","838":"b6b53d8c"}[chunkId] + ".js";
};